export const convertArrayToCSV = (array) => {
  if (!array || !array.length) return '';
  const separator = ',';
  const keys = Object.keys(array[0]);
  
  const csvContent =
    keys.join(separator) +
    '\n' +
    array.map(row => {
      return keys.map(k => {
        let cell = row[k] === null || row[k] === undefined ? '' : row[k];
        
        // Handle objects (like price_model or arrays) roughly for CSV
        if (typeof cell === 'object') {
          cell = JSON.stringify(cell).replace(/"/g, "'");
        }
        
        cell = cell.toString();
        cell = cell.replace(/"/g, '""'); // Escape double quotes
        
        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator);
    }).join('\n');
    
  return csvContent;
};

export const downloadCSV = (csv, filename) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const parseCSV = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      if (!text) return resolve([]);
      
      const lines = text.split('\n');
      if (lines.length < 2) return resolve([]);

      const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
      const result = [];

      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        
        const row = lines[i].match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g) || lines[i].split(',');
        
        if (!row) continue;

        const obj = {};
        headers.forEach((header, index) => {
          let val = row[index] ? row[index].trim() : '';
          
          if (val.startsWith('"') && val.endsWith('"')) {
            val = val.slice(1, -1);
            val = val.replace(/""/g, '"');
          }
          
          if ((val.startsWith('{') || val.startsWith('[')) && val.includes("'")) {
             try {
                obj[header] = JSON.parse(val.replace(/'/g, '"'));
             } catch (e) {
                obj[header] = val;
             }
          } else {
             obj[header] = val;
          }
        });
        result.push(obj);
      }
      resolve(result);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
};